// extracted by mini-css-extract-plugin
module.exports = {"title":"DeliveryServices_title__4dMCP","services":"DeliveryServices_services___5_5B"};